export const getRelatedPosts = (state, postId) => state.relatedPosts[postId];
